<template>
  <v-container>
    <Modal v-if="showModal" max-width="1200" :show.sync="showModal" :close="closeModal" :show-dividers="false">
      <template #title>
        <v-row class="justify-end" no-gutters>
          <v-icon @click="closeModal">mdi-close</v-icon>
        </v-row>
      </template>
      <template #text>
        <v-tabs v-model="currentTab" vertical>
          <v-tab v-for="(tab, index) in tabs" :key="`v-tab-header-${index}`" class="justify-start">
            <v-icon left>
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.label }}</span>
          </v-tab>

          <v-tabs-slider color="red" />

          <v-tabs-items v-model="currentTab">
            <v-tab-item v-for="(tab, index) in tabs" :key="`v-tab-item-${index}`">
              <div v-if="loadingOrders" class="d-flex justify-center align-center" style="min-height: 500px;">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="64"
                />
              </div>
              <component 
                v-else-if="(index === currentTab) || componentInDOM"
                :is="tab.component" 
                :customer="customer" 
                :contract="contract" 
                :selected-order="order"
                :initial-stock="initialStock"
                :all-contract-orders="allContractOrders"
                :contract-history="contractHistory"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </template>
    </Modal>
  </v-container>
</template>
<script>
import { requests, EventBus } from '@/mixins/index';
import Modal from '@/components/Modal/Modal';
import UpdateStock from '@/components/order/UpdateStock';
import UpdateStockHistory from '@/components/order/UpdateStockHistory';
import ContractSessionHistory from '@/components/order/ContractSessionHistory';

export default {
  components: { Modal, UpdateStock, UpdateStockHistory, ContractSessionHistory },
  mixins: [requests],
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    customer: {
      type: Object,
      default: () => {}
    },
    fetchedOrders: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showModal: false,
      currentTab: 0,
      updatedHistory: false,
      allContractOrders: [],
      contractHistory: [],
      loadingOrders: false
    };
  },
  computed: {
    tabs () {
      return [
        { tabKey: 'updateStock', icon: 'mdi-plus-circle-outline', label: 'Mettre à jour le stock', component: 'UpdateStock' },
        { tabKey: 'stockHistory', icon: 'mdi-note-edit-outline', label: 'Historique des Modifications', component: 'UpdateStockHistory' },
        { tabKey: 'contractSessions', icon: 'mdi-note-edit-outline', label: 'Historique des sessions', component: 'ContractSessionHistory' }
      ];
    },
    contract () {
      if (!this.$props.order) return null;

      const orderItem = this.$props.order.order.order_items.find(item => item.customer.uuid === this.$props.customer.uuid);

      if (!orderItem) return null;

      return orderItem.contract ? {...orderItem.contract, workspace: this.$props.order.siteWorkspaceCode} : null;
    },
    componentInDOM () {
      return this.updatedHistory;
    },
    initialStock () {
      if (!this.contract) {
        return 0;
      }

      if (!this.contract.orderUuids || this.contract.orderUuids.length <= 1) {
        return parseInt(this.contract.initialStock) || 0;
      }

      let totalStock = 0;

      if (this.allContractOrders && this.allContractOrders.length) {
        this.allContractOrders.forEach(order => {
          order.order.order_items.forEach(item => {
            if (item.customer.uuid === this.customer.uuid) {
              totalStock = totalStock + (parseInt(item.stock) * parseInt(item.quantity));
            }
          });
        });
      }

      return totalStock;
    }
  },
  mounted () {
    EventBus.$on('show-stock-update-modal', async () => {
      this.newStockQuantity = null;
      this.observation = null;
      this.showModal = true;
      await this.loadContractData();
    });

    /* Event to manipulate the re render of tabs to be able to execute mounted() */
    EventBus.$on('up-to-date-contract-history', async bool => {
      this.updatedHistory = bool;
      // Reload contract history when stock is updated (bool = false)
      if (bool === false) {
        await this.loadContractHistory();
      }
    });
  },
  methods: {
    async loadContractData () {
      if (!this.contract) return;

      this.loadingOrders = true;
      try {
        await Promise.all([this.loadAllContractOrders(), this.loadContractHistory()]);
      } catch (error) {
        console.error('Error loading contract data:', error);
        const notification = {
          message: 'Erreur lors de la récupération des données du contrat',
          type: 'danger',
          timeout: 10000
        };
        EventBus.$emit('show-notifications', [notification]);
      } finally {
        this.loadingOrders = false;
      }
    },
    async loadAllContractOrders () {
      if (!this.contract || !this.contract.orderUuids) {
        this.allContractOrders = [];
        return;
      }

      const allContractOrders = [];
      const ordersToFetch = [];

      this.contract.orderUuids.forEach(orderUuid => {
        const order = this.fetchedOrders.find(order => order.uuid === orderUuid);
        if (order) {
          allContractOrders.push(order);
        } else {
          ordersToFetch.push(orderUuid);
        }
      });

      if (ordersToFetch.length) {
        const response = await this.getOrders(0, ordersToFetch.length, this.customer.uuid, 'alpha', undefined, ordersToFetch.map(orderUuid => `uuid:${orderUuid}`).join(' OR '));
        if (response.success && response.data && response.data.items && response.data.items.length) {
          allContractOrders.push(...response.data.items);
        }
      }

      this.allContractOrders = allContractOrders;
    },
    async loadContractHistory () {
      if (!this.contract || !this.contract.contractNumber) {
        this.contractHistory = [];
        return;
      }

      const response = await this.getContractHistory(this.customer.uuid, this.contract.contractNumber);
      if (response.success) {
        this.contractHistory = response.data || [];
      } else {
        this.contractHistory = [];
      }
    },
    closeModal () {
      this.newStockQuantity = null;
      this.observation = null;
      this.showModal = false;
      this.currentTab = 0;
    }
  }
};
</script>
